// Mock data for Ace Asia Productions e-commerce frontend.
// ⚠️ BACKEND INTEGRATION POINT
// Replace these arrays with API calls (see services/api.js).

export const ASSETS = {
  founderPortrait:
    "https://customer-assets.emergentagent.com/job_premium-publishing-1/artifacts/aj54shxl_Chantal%20Sajan.png",
  founderEditorial:
    "https://customer-assets.emergentagent.com/job_premium-publishing-1/artifacts/4moybsov_Picture%201.png",
  podcastCover:
    "https://customer-assets.emergentagent.com/job_premium-publishing-1/artifacts/ugpufe8e_Picture%202.jpg",
  bookCoverDark:
    "https://customer-assets.emergentagent.com/job_premium-publishing-1/artifacts/vm411et7_IMG_9031.png",
  bookCoverLight:
    "https://customer-assets.emergentagent.com/job_premium-publishing-1/artifacts/w4s4ibak_IMG_9034.jpg",
  // Collectibles — client-provided product photography (served from public/collectibles)
  bananaLeaf: "/collectibles/banana-leaf-plates.png",
  lotusBowls: "/collectibles/lotus-glass-set.png",
  batikTeapotDark: "/collectibles/batik-teapot-dark.png",
  batikTeapotFloral: "/collectibles/batik-teapot-floral.png",
  batikTeacupDark: "/collectibles/batik-teacup-dark.png",
  batikTeacup: "/collectibles/batik-teacup.png",
  facadeFullertonLit: "/collectibles/facade-fullerton-lit.jpg",
  facadeFullerton: "/collectibles/facade-fullerton.jpg",
  facadeShophouses: "/collectibles/facade-shophouses.png",
  facadeBuilding: "/collectibles/facade-building.png",
};

export const STOCK_STATUSES = {
  in_stock: { label: "In Stock", tone: "green" },
  low_stock: { label: "Low Stock", tone: "amber" },
  sold_out: { label: "Sold Out", tone: "red" },
  pre_order: { label: "Pre-Order", tone: "gold" },
  coming_soon: { label: "Coming Soon", tone: "neutral" },
  stocks_to_come: { label: "Update on Stocks to Come", tone: "gold" },
};

export const MOCK_PRODUCTS = [
  {
    id: "bk-chettis-01",
    sku: "AA-BK-001",
    title: "The Chettis of South-east Asia",
    author: "Chantal Sajan",
    category: "books",
    price: 29.9,
    shippingCost: 3.0,
    currency: "SGD",
    isbn: "978-981-94-6844-7",
    image: ASSETS.bookCoverLight,
    gallery: [ASSETS.bookCoverLight, ASSETS.bookCoverDark],
    shortDescription:
      "A ground-breaking new exploration of one of South-east Asia's most fascinating yet little-known communities, written and published by Ms Sajan.",
    description:
      "Discover the untold story of the Chetti Melaka — the Indian Peranakans of Singapore and Malaysia — and their remarkable connections to trade, culture and civilisation stretching back more than 2,000 years.",
    longDescription:
      "Far more than a community history, The Chettis of South-east Asia uncovers extraordinary links between South-east Asia and ancient global trade routes. 350-page paperback. Launching September 2026.",
    stockStatus: "in_stock",
    stockQty: 500,
    availabilityDate: "2026-09-15",
    featured: true,
    pages: 350,
    format: "Paperback",
  },
  {
    id: "co-banana-leaf-01",
    sku: "AA-CO-101",
    title: "Banana Leaf Tableware Collection",
    category: "collectibles",
    subcategory: "tableware",
    price: 128.0,
    currency: "SGD",
    priceTBA: true,
    image: ASSETS.bananaLeaf,
    gallery: [ASSETS.bananaLeaf],
    shortDescription:
      "Banana-leaf-inspired serving plates honouring Chetti Melaka offerings.",
    description:
      "The banana leaf takes on added significance for the community who practise ancestor worship through food offerings placed on banana leaves.",
    longDescription:
      "Glassware recreating the delicate design of the banana leaf, hand-finished to capture its elegance — central to Chetti Melaka cuisine and heritage.",
    stockStatus: "stocks_to_come",
    stockQty: 80,
    availabilityDate: "2027-02-01",
    featured: false,
  },
  {
    id: "co-lotus-bowl-01",
    sku: "AA-CO-102",
    title: "Lotus-Inspired Serving Bowls",
    category: "collectibles",
    subcategory: "tableware",
    price: 92.0,
    currency: "SGD",
    priceTBA: true,
    image: ASSETS.lotusBowls,
    gallery: [ASSETS.lotusBowls],
    shortDescription:
      "Lotus-form bowls inspired by Hindu temple worship traditions.",
    description:
      "Lotus-inspired serving bowls hark back to Hindu temple worship, a fixture for the Chetti Melaka community who were staunch Hindus despite appearing as part of the Malay community in the region and sharing Malay recipes such as Ikan Assam Pedas and Ayam Buah Keluak.",
    longDescription:
      "Hand-crafted with the lotus form, a symbol revered across Hindu temple worship — a quiet emblem of the community's enduring spiritual fabric.",
    stockStatus: "stocks_to_come",
    stockQty: 60,
    availabilityDate: "2027-02-01",
    featured: false,
  },
  {
    id: "co-batik-teapot-01",
    sku: "AA-CO-201",
    title: "Heritage Batik Teapot & Teacup Set",
    category: "collectibles",
    subcategory: "tea",
    price: 168.0,
    currency: "SGD",
    priceTBA: true,
    image: ASSETS.batikTeapotDark,
    gallery: [
      ASSETS.batikTeapotDark,
      ASSETS.batikTeacupDark,
      ASSETS.batikTeapotFloral,
      ASSETS.batikTeacup,
    ],
    shortDescription:
      "Tablescapes celebrating sarong kebaya and 1500s batik motifs.",
    description:
      "Chantal Sajan is collaborating with ASEAN artisans and production houses to bring to life the essence of Chetti Melaka heritage through tablescapes that celebrate the beauty of the sarong kebaya and batik textile designs dating back to the 1500s.",
    longDescription:
      "Teapots with mediaeval batik textile print designs worn by Chantal's ancestors dating back to the 15th century in old Melaka, Malaysia.",
    stockStatus: "stocks_to_come",
    stockQty: 40,
    availabilityDate: "2027-03-01",
    featured: true,
  },
  {
    id: "co-facade-01",
    sku: "AA-CO-301",
    title: "Architectural Facades Collection",
    category: "collectibles",
    subcategory: "architecture",
    price: 220.0,
    currency: "SGD",
    priceTBA: true,
    image: ASSETS.facadeFullertonLit,
    gallery: [
      ASSETS.facadeFullertonLit,
      ASSETS.facadeFullerton,
      ASSETS.facadeShophouses,
      ASSETS.facadeBuilding,
    ],
    shortDescription:
      "Picture-postcard shophouses, Fullerton, Raffles — Singapore's past in object form.",
    description:
      "Also coming up in 2027 is a range of architectural facades that evoke Singapore's past such as the General Post Office Building (now Fullerton Hotel Singapore), Raffles Hotel Singapore and the island's picture-postcard shophouses.",
    longDescription:
      "A curated series of architectural facade sculptures that bring Singapore's heritage architecture into the home — collectible miniatures finished with old-world detail.",
    stockStatus: "stocks_to_come",
    stockQty: 25,
    availabilityDate: "2027-04-01",
    featured: false,
  },
];

export const FEATURE_HIGHLIGHTS = [
  {
    title: "Origins",
    body: "The deeply rooted origins and evolution of the Chetti Melaka community.",
  },
  {
    title: "Maritime Trade",
    body: "Early maritime trade networks connecting cultures across ancient Asia.",
  },
  {
    title: "Global Reach",
    body: "Fascinating historical connections reaching as far as Rome and beyond.",
  },
  {
    title: "Archaeology",
    body: "New archaeological insights such as the recent return of the Leiden Copper Plates from The Netherlands to India that reframe what we know about the Indian traders of Ancient Asia.",
  },
  {
    title: "Hidden Heritage",
    body: "Uncovering lost cultural traditions and preserving hidden heritage.",
  },
  {
    title: "Modern Scholarship",
    body: "Fresh perspectives and insights drawn from modern academic research.",
  },
];

export const MOCK_ORDERS = [
  {
    orderId: "AA-2026-00141",
    customerName: "Anjali Menon",
    email: "anjali.menon@example.com",
    products: [{ title: "The Chettis of South-east Asia", qty: 1, price: 48 }],
    total: 56.0,
    paymentStatus: "paid",
    deliveryStatus: "shipped",
    createdAt: "2026-10-04T08:24:00Z",
    updatedAt: "2026-10-07T11:02:00Z",
    trackingNotes: "Dispatched via SingPost — tracking SG3471190029SG.",
  },
  {
    orderId: "AA-2026-00142",
    customerName: "Lim Wei Jie",
    email: "weijie.lim@example.com",
    products: [
      { title: "Heritage Batik Teapot & Teacup Set", qty: 1, price: 168 },
    ],
    total: 178.0,
    paymentStatus: "pending",
    deliveryStatus: "order_received",
    createdAt: "2026-10-05T15:10:00Z",
    updatedAt: "2026-10-05T15:10:00Z",
    trackingNotes: "Awaiting payment confirmation.",
  },
  {
    orderId: "AA-2026-00143",
    customerName: "Devi Krishnan",
    email: "devi.k@example.com",
    products: [
      { title: "Lotus-Inspired Serving Bowls", qty: 2, price: 92 },
      { title: "The Chettis of South-east Asia", qty: 1, price: 48 },
    ],
    total: 240.0,
    paymentStatus: "paid",
    deliveryStatus: "out_for_delivery",
    createdAt: "2026-10-02T10:00:00Z",
    updatedAt: "2026-10-08T07:45:00Z",
    trackingNotes: "Last-mile courier dispatched in Singapore.",
  },
];

export const DELIVERY_STATUSES = [
  { key: "order_received", label: "Order Received" },
  { key: "payment_confirmed", label: "Payment Confirmed" },
  { key: "preparing", label: "Preparing Order" },
  { key: "ready_for_dispatch", label: "Ready for Dispatch" },
  { key: "shipped", label: "Shipped" },
  { key: "out_for_delivery", label: "Out for Delivery" },
  { key: "delivered", label: "Delivered" },
  { key: "delayed", label: "Delayed" },
  { key: "cancelled", label: "Cancelled" },
];

export const MOCK_CONTACTS = [
  {
    id: "ct-001",
    name: "Ramesh Pillai",
    email: "ramesh.p@example.com",
    phone: "+65 9123 4567",
    subject: "Bulk order enquiry — academic library",
    message:
      "We would like to enquire about bulk orders of The Chettis of South-east Asia for our university research collection.",
    createdAt: "2026-10-06T09:32:00Z",
  },
  {
    id: "ct-002",
    name: "Siti Rahmah",
    email: "siti.r@example.com",
    phone: "+65 8910 2233",
    subject: "Podcast collaboration",
    message:
      "I'd love to discuss featuring our heritage textile workshop on the Chantal & Co podcast series.",
    createdAt: "2026-10-07T14:11:00Z",
  },
];

export const MOCK_MULTIMEDIA = [
  {
    id: "ep-01",
    title: "Heritage in the Modern City",
    description:
      "A conversation on Singapore's vanishing shophouses and the architecture of memory.",
    thumbnail: ASSETS.podcastCover,
    youtubeUrl: "https://www.youtube.com/@Chantalandco/videos",
    duration: "32 min",
    season: "Season 3",
    featured: true,
  },
  {
    id: "ep-02",
    title: "The Chetti Melaka — A Living Lineage",
    description:
      "Historians and elders unpack the cultural fabric of the Chetti Melaka community.",
    thumbnail: ASSETS.podcastCover,
    youtubeUrl: "https://www.youtube.com/@Chantalandco/videos",
    duration: "28 min",
    season: "Season 3",
    featured: false,
  },
  {
    id: "ep-03",
    title: "Batik, Banana Leaf & Belonging",
    description:
      "Material culture as identity — from kebaya to ceremonial plate.",
    thumbnail: ASSETS.podcastCover,
    youtubeUrl: "https://www.youtube.com/@Chantalandco/videos",
    duration: "24 min",
    season: "Season 3",
    featured: false,
  },
];

export const COMPANY = {
  name: "Ace Asia Productions Pte Ltd",
  uen: "202626404G",
  email: "info@aceasia.com.sg",
  phone: "+65 9199 4901",
  whatsapp: "https://wa.me/6591994901",
  socials: {
    tiktok: "https://www.tiktok.com/@chantalandco.sg",
    youtube: "https://www.youtube.com/@Chantalandco/videos",
    instagram: "https://www.instagram.com/chantalandco.sg/",
    facebook: "https://www.facebook.com/profile.php?id=61578733720935",
  },
};
